export const StandardKeyMetrics = {
  conversion: [
    "conversionRate",
    "addToCartRate",
    "abandonedCartRate",
    "checkoutBeginRate",
    "checkoutEnterContactInfoRate",
    "checkoutAddressSubmittedRate",
    "abandonedCheckoutRate",
    "viewProductPageRate",
    "viewCollectionPageRate",
    "pctOrdersWithPostPurchaseOffer",
    "pctOrdersWithUpsell",
    "pctOrdersWithOnsiteUpsell",
  ],
  revenue: [
    "netRevenuePerVisitor",
    "netRevenuePerOrder",
    "avgUnitsPerOrder",
    "avgProductRevenuePerUnit",
    "netRevenueFromPostPurchaseOffer",
    "netRevenueFromUpsell",
    "netRevenueFromOnsiteUpsell",
  ],
  profit: ["profitPerVisitor", "profitPerOrder"],
  shipping: ["pctOrdersFreeShipping", "netShippingRevenuePerOrder"],
  subscription: [
    "subscriptionOrdersPerVisitor",
    "subscriptionRevenuePerVisitor",
    "subscriptionProfitPerVisitor",
    "subscriptionRevenuePerOrder",
    "pctSubscriptionOrders",
  ],
  discount: ["avgDiscountPerAllOrders", "avgDiscountPerDiscountedOrder"],
};

export const InvertedMetrics = ["abandonedCartRate", "abandonedCheckoutRate"];
